"use strict"
import React, { Component, PropTypes as ReactPropTypes } from "react";
import { PropTypes } from "Subschema";
import Anchor from "../types/anchor/Anchor.jsx";
import { pageInfo } from '../PropTypes';
import OpinionLab from '../Opinionlab'


const links = [
  {
      "type": "Anchor",
      "target": "_blank",
      "content": "Privacy",
      "href": "/us/webapps/mpp/ua/privacy-full?country.x=us&locale.x=en_US"
  }, {
      "type": "Anchor",
      "target": "_blank",
      "content": "Legal",
      "href": "/us/webapps/mpp/ua/legalhub-full?country.x=us&locale.x=en_US"
  }, {
      "type": "Anchor",
      "target": "_blank",
      "content": "Contact",
      "href": "/us/webapps/helpcenter/helphub/home/?country.x=us&locale.x=en_US"
  }];


export default class FooterTemplate extends Component {
    static propTypes = {
        styleClass: PropTypes.style,
        Anchor: PropTypes.injectClass
    };

    static defaultProps = {
        copyRightYear: new Date().getYear() + 1900,
        countryFlag: "/signup/account?vt=true#openCountryList",
        country: 'US',
        locality: 'en',
        styleClass: "Footer",
        Anchor: Anchor,
        links
    };

    static contextTypes = {
        pageInfo
    };

    wrapFooterLink(footerLink, i) {
        const Anchor = this.props.Anchor;
        return <li key={`footer-anchor-${i}`}><Anchor {...footerLink}/></li>;
    }

    render() {
        const {
          Anchor,
          footerClass,
          flagClass,
          footerNavClass,
          copyrightClass,
          country,
          locality,
          links
        } = this.props;

        const {
          pageInfo: {
            rLogId,
            fptiPgrp,
            hostName
          } = {}
        } = this.context || {}

        const OpinionLabProps = {
          rLogId,
          fptiPgrp,
          hostName,
          country,
          locality
        }

        const opinionLabUrl = OpinionLab.constructOpinionLabUrl(null,OpinionLabProps)

        const feedBackLink = {
            type: "Anchor",
            content: "Feedback",
            href: "#",
            openInNewWindowUrl: opinionLabUrl,
            newWindowWidth: 500,
            newWindowHeight: 300,
            newWindowTitle: "Feedback"
          }

        return (
            <footer id="gblFooter" role="contentinfo" className={footerClass}>
                <p className={copyrightClass}>© {this.props.copyRightYear} PayPal</p>
                <ul className={footerNavClass}>
                    {[...links, feedBackLink].map(this.wrapFooterLink, this)}
                </ul>
                <span className={`${flagClass} ${this.props.country}_FLAG`}/>
                <OpinionLab {...OpinionLabProps}/>
            </footer>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/templates/FooterTemplate.jsx
 **/